import { useEffect } from 'react'
import { useUserAuthSessionStore } from '@/store/useUserAuthSessionStore'
import { authEventEmitter } from '@/utils/eventEmitters/authEventEmitter'

export const useRegisterAuthListener = () => {
  const removeSession = useUserAuthSessionStore((s) => s.removeSession)

  useEffect(() => {
    const onLogout = () => {
      removeSession()

      // Redirect to the authentication page
      if (typeof window !== 'undefined') {
        setTimeout(() => {
          window.location.href = '/auth/identification-method'
        }, 100)
      }
    }

    authEventEmitter.on('logout', onLogout)
    return () => {
      authEventEmitter.off('logout', onLogout)
    }
  }, [removeSession])
}
